<template>
  <footer>
    <hr />
    <div class="container">
      <p class="text-right applicationtext">
        <a :href="termsOfTradeUrl" target="_blank">{{
          $t("footer_terms_trade")
        }}</a>
        |
        <a :href="imprintUrl" target="_blank">{{ $t("footer_imprint") }}</a>
        |
        <a :href="privacyUrl" target="_blank">{{ $t("footer_policy") }}</a>
        |
        <a :href="termsOfUseUrl" target="_blank">{{
          $t("footer_terms_use")
        }}</a>
        |
        <a href="documents/References.pdf" target="_blank">{{
          $t("footer_references")
        }}</a>
      </p>
      <p class="text-right applicationtext">
        &copy; {{ $t("footer_address") }}
        <a href="mailto:info@erbe-med.com">{{ $t("footer_email") }}</a>
      </p>
    </div>
  </footer>
</template>

<script>
import links from "@/data/links.json";
import { languageAdapter } from "@/services/languageAdapter";
export default {
  name: "FooterIndex",
  computed: {
    termsOfTradeUrl() {
      return links[this.$store.state.language].termsOfTrade;
    },
    termsOfUseUrl() {
      return links[this.$store.state.language].termsOfUse;
    },
    imprintUrl() {
      return links[this.$store.state.language].imprint;
    },
    privacyUrl() {
      return links[this.$store.state.language].privacy;
    }
  }
};
</script>

<style scoped>
footer {
  background: white;
  padding: 20px 0;
}
footer .glyphicon {
  color: #333333;
  font-size: 60px;
}
footer .glyphicon:hover {
  color: #306d9f;
}
</style>
